var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.956 10.692 25.55 5.38a1.41 1.41 0 0 1 1.726 1.727L21.964 25.7c-.398 1.195-1.992 1.328-2.523.133l-3.72-8.767-8.765-3.719c-1.329-.664-1.196-2.258 0-2.656Z",
    fill: "#10A8BA"
  })));
};
export default SvgLocation;